import React, { Component } from "react";
import "./assets/img/apple-touch-icon.png";
import "./assets/img/favicon.png";
// import "./assets/vendor/aos/aos.css";
import ReactTyped from "react-typed";
import { withRouter } from "../../../withRouter";
import Footer from "./Footer";
import Header from "./Header";
import "./Home.css";
import "./assets/css/style.css";
import geHealthcare from "./assets/img/General_Electric_Healthcare_BLUE-600x202.jpg";
import agco from "./assets/img/cropped-AGCO-2.jpg";
import BBISVPartner from "./assets/img/cropped-BBISVPartner.png";
import ibm from "./assets/img/cropped-IBMlogo-5.jpg";
import IndianaRecy from "./assets/img/cropped-IndianaRecy_Logo-1-1.jpg";
import mtmp from "./assets/img/cropped-MTMPlogo.jpg";
import mercer from "./assets/img/cropped-MercerLogo-1.jpg";
import nfp from "./assets/img/cropped-NFPlogo-1.jpg";
import trialLawyers from "./assets/img/cropped-NTLlogo-2.jpg";
import pathways from "./assets/img/cropped-PrudentialPath_logo-1.jpg";
import usRetina from "./assets/img/cropped-USRetinalogo-1.jpg";
import zillowGroup from "./assets/img/cropped-Zillowlogo-3.jpg";
import condosites from "./assets/img/cropped-condosites.png";
import neonOne from "./assets/img/cropped-cropped-N1-Logo-2020-wh-lg-03.png";
import cvent from "./assets/img/cropped-cropped-cvent-logo.png";
import croppedDonor from "./assets/img/cropped-donor-1.png";
import cropped from "./assets/img/cropped-mock-T.png";
import givBeeLogo from "./assets/img/givbeeLogo.png";
import grandoaks from "./assets/img/grandoakslogo-300x76.jpg";
import "./assets/vendor/bootstrap-icons/bootstrap-icons.css";
import "./assets/vendor/bootstrap/css/bootstrap.min.css";
import "./assets/vendor/boxicons/css/boxicons.min.css";
import "./assets/vendor/glightbox/css/glightbox.min.css";
import "./assets/vendor/remixicon/remixicon.css";
import "./assets/vendor/swiper/swiper-bundle.min.css";
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <>
          <Header />

          {/* ======= Hero Section ======= */}
          <section
            id="hero"
            className="d-flex align-items-center"
            style={{ backgroundColor: "#37517e" }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-6 pt-5 pt-lg-0 order-2 order-lg-1 d-flex flex-column justify-content-center">
                  <div className="row" style={{ margin: "3em 0em" }}>
                    <div className="col-md-12">
                      <img
                        src={givBeeLogo}
                        className="img-fluid animated"
                        alt=""
                        style={{ width: "50%" }}
                      />
                    </div>
                  </div>
                  <h1
                    data-aos="fade-up"
                    style={{
                      color: "#fff",
                      fontWeight: "600",
                      fontSize: "35px",
                    }}
                  >
                    It's the TEXT way to...
                  </h1>

                  <h2
                    data-aos="fade-up"
                    data-aos-delay={400}
                    style={{
                      color: "#fff",
                      fontWeight: "600",
                    }}
                  >
                    <>
                      <ReactTyped
                        // typedRef={typedRef()}
                        loop
                        typeSpeed={200}
                        backSpeed={200}
                        strings={[
                          "reach your audience",
                          "raise funds",
                          "remind a group",
                          "promote a product",
                          "alert a crowd",
                          "share big news",
                        ]}
                        smartBackspace
                        shuffle={false}
                        backDelay={1}
                        fadeOut={false}
                        fadeOutDelay={100}
                        loopCount={0}
                        showCursor
                        cursorChar="|"
                      />
                    </>
                  </h2>
                  <div data-aos="fade-up" data-aos-delay={800}>
                    <a href="#about" className="btn-get-started scrollto">
                      Get Started Now
                    </a>
                    &nbsp; &nbsp; &nbsp;
                    <a href="#about" className="btn-get-learn scrollto">
                      Learn More
                    </a>
                  </div>
                </div>
                <div
                  className="col-lg-6 order-1 order-lg-2 hero-img"
                  data-aos="fade-left"
                  data-aos-delay={200}
                  style={{ textAlign: "right" }}
                >
                  <img
                    src={cropped}
                    className="img-fluid animated"
                    alt=""
                    style={{ width: "80%" }}
                  />
                </div>
              </div>
            </div>
          </section>
          {/* End Hero */}
          <main id="main">
            {/* ======= Clients Section ======= */}
            <section id="clients" className="clients clients">
              <div className="container" style={{ padding: "1em 2em" }}>
                <div className="row">
                  <h4>
                    Simplify your business communication and customer
                    experiences through text.
                  </h4>
                  <div className="col-lg-3 col-md-6 col-9" id="clientBox">
                    <div className="count-box" id="automatedText">
                      <span>
                        <i className="fa icon color7 fa-heart bordered round color2" />
                      </span>

                      <h5>NONPROFITS</h5>
                      <div className="btn-wrap">
                        <a href="/nonprofits" className="btn-buy">
                          Learn More
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-9" id="clientBox">
                    <div className="count-box" id="automatedText">
                      <span>
                        <i className="fa icon fa-group bordered round color7" />
                      </span>

                      <h5>EVENTS</h5>
                      <div className="btn-wrap">
                        <a href="/eventtext" className="btn-buy">
                          Learn More
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-9" id="clientBox">
                    <div className="count-box" id="automatedText">
                      <span>
                        <i className="fa icon fa-shopping-bag bordered round color7" />
                      </span>

                      <h5>SMALL BUSINESSES</h5>
                      <div className="btn-wrap">
                        <a href="#" className="btn-buy">
                          Learn More
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-9" id="clientBox">
                    <div className="count-box" id="automatedText">
                      <span>
                        <i className="fa icon fa-cutlery bordered round color7" />
                      </span>

                      <h5>RESTAURANTS/FOODTRUCKS</h5>
                      <div className="btn-wrap">
                        <a
                          href="/restaurant-and-food-truck-texting"
                          className="btn-buy"
                        >
                          Learn More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* End About Us Section */}
            {/* ======= Counts Section ======= */}
            <section id="counts" className="counts">
              <div className="container" style={{ padding: "6em 6em 0em 6em" }}>
                <div className="section-title" data-aos="fade-up">
                  <h2 style={{ textTransform: "math-auto" }}>
                    An automated text system has it all.
                  </h2>
                </div>
                <div className="row" id="autoSystemIcon">
                  <div
                    className="col-xl-12 d-flex align-items-stretch pt-4 pt-xl-0"
                    data-aos="fade-left"
                    data-aos-delay={300}
                  >
                    <div className="content d-flex flex-column justify-content-center">
                      <div className="row">
                        <div
                          className="col-md-3 d-md-flex align-items-md-stretch"
                          id="automatedTextCol"
                        >
                          <div className="count-box" id="automatedText">
                            <span>
                              <i className="fa fa-commenting-o" />
                            </span>

                            <h5>SIMPLE EXPERIENCE</h5>
                            <p>
                              Send text reminders, updates and info to your
                              entire opt-in list or to targeted groups in a few
                              easy clicks.
                            </p>
                          </div>
                        </div>
                        <div
                          className="col-md-3 d-md-flex align-items-md-stretch"
                          id="automatedTextCol"
                        >
                          <div className="count-box" id="automatedText">
                            <span>
                              <i className="fa icon color8 fa-mail-reply-all big color7" />
                            </span>{" "}
                            <h5>AUTO-REPLY</h5>
                            <p>
                              Allow your audience to access your content
                              wherever and whenever through the use of trigger
                              keywords.
                            </p>
                          </div>
                        </div>
                        <div
                          className="col-md-3 d-md-flex align-items-md-stretch"
                          id="automatedTextCol"
                        >
                          <div className="count-box" id="automatedText">
                            <span>
                              {" "}
                              <i className="fa fa-calendar-check-o" />
                            </span>

                            <h5>SCHEDULED SENDS</h5>
                            <p>
                              Schedule text messages in advance and get alerts
                              to your phone or email when people respond to your
                              texts.
                            </p>
                          </div>
                        </div>
                        <div
                          className="col-md-3 d-md-flex align-items-md-stretch"
                          id="automatedTextCol"
                        >
                          <div className="count-box" id="automatedText">
                            <span>
                              <i className="fa icon color8 fa-codepen big color7" />
                            </span>
                            <h5>WEB WIDGETS</h5>

                            <p>
                              Message-specific widgets enable you to deliver
                              info on demand and automatically segment your
                              audience into distinct groups.
                            </p>
                          </div>
                        </div>
                        <div
                          className="col-md-3 d-md-flex align-items-md-stretch"
                          id="automatedTextCol"
                        >
                          <div className="count-box" id="automatedText">
                            <span>
                              <i className="fa icon big color8 fa-file-excel-o color7" />
                            </span>
                            <h5>REAL-TIME REPORTS</h5>

                            <p>
                              Review text activity in the form of real-time
                              reports that show you who, when and how people are
                              responding to your campaigns.
                            </p>
                          </div>
                        </div>
                        <div
                          className="col-md-3 d-md-flex align-items-md-stretch"
                          id="automatedTextCol"
                        >
                          <div className="count-box" id="automatedText">
                            <span>
                              <i className="fa icon color8 fa-users big color7" />
                            </span>
                            <h5>LIST SEGMENTATION</h5>

                            <p>
                              Create your own custom texting groups for outside
                              groups and internal teams.
                            </p>
                          </div>
                        </div>
                        <div
                          className="col-md-3 d-md-flex align-items-md-stretch"
                          id="automatedTextCol"
                        >
                          <div className="count-box" id="automatedText">
                            <span>
                              <i className="fa icon color8 fa-cc-paypal big color7" />
                            </span>
                            <h5>SECURE PAYMENT</h5>

                            <p>
                              PayPal integration makes payment convenient and
                              secure for you and your recipients.
                            </p>
                          </div>
                        </div>
                        <div
                          className="col-md-3 d-md-flex align-items-md-stretch"
                          id="automatedTextCol"
                        >
                          <div className="count-box" id="automatedText">
                            <span>
                              <i className="fa icon color8 fa-list big color7" />
                            </span>
                            <h5>POLLS & SURVEYS</h5>

                            <p>
                              Create and send cutom automated, text-based polls,
                              surveys or feedback requests that get instant
                              results.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* End .content*/}
                  </div>
                </div>
              </div>
            </section>
            <section id="about" className="about">
              <div className="container" style={{ padding: "2em 6em 0em" }}>
                <div className="section-title" data-aos="fade-up">
                  <h2>Did you know?</h2>
                </div>
                <div className="row content">
                  <div
                    className="col-lg-4"
                    data-aos="fade-up"
                    data-aos-delay={150}
                  >
                    <div className="count-box" id="didKnowCountBox">
                      <h4>98%</h4>

                      <h5>
                        OF TEXTS ARE READ WITHIN 3 MINS OF BEING RECEIVED.
                      </h5>
                    </div>
                  </div>
                  <div
                    className="col-lg-4"
                    data-aos="fade-up"
                    data-aos-delay={150}
                  >
                    <div className="count-box" id="didKnowCountBox">
                      <h4>97%</h4>

                      <h5>OF SMARTPHONE USERS SAY THEY TEXT REGULARLY.</h5>
                    </div>
                  </div>
                  <div
                    className="col-lg-4"
                    data-aos="fade-up"
                    data-aos-delay={150}
                  >
                    <div className="count-box" id="didKnowCountBox">
                      <h4>88%</h4>

                      <h5>OF MARKETING EMAILS GO UNOPENED.</h5>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* End Counts Section */}
            {/* ======= Services Section ======= */}
            <section id="services" className="services">
              <div className="container">
                <div className="section-title" data-aos="fade-up">
                  <h2>More reasons to go with GivBee.</h2>
                </div>
                <div className="row">
                  <div
                    className="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0"
                    id="colBox"
                  >
                    <div
                      className="icon-box"
                      data-aos="fade-up"
                      data-aos-delay={100}
                    >
                      <div className="icon">
                        <i className="fa icon fa-handshake-o reverse round big color2" />
                      </div>
                      <h4 className="title">
                        <a href="">INTEGRATED</a>
                      </h4>
                      <p className="description">
                        GivBee integrates many of the top event and donor
                        management tools: Cvent, DonorPerfect, NeonCRM, Raiser’s
                        Edge, PayPal & Sweet.
                      </p>
                    </div>
                  </div>
                  <div
                    className="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0"
                    id="colBox"
                  >
                    <div
                      className="icon-box"
                      data-aos="fade-up"
                      data-aos-delay={200}
                    >
                      <div className="icon">
                        <i className="fa icon fa-cubes reverse round big color2" />
                      </div>
                      <h4 className="title">
                        <a href="">FEATURE-RICH</a>
                      </h4>
                      <p className="description">
                        Whether you send simple texts or want to setup
                        interactive text experiences, GivBee has the templates
                        and tools to make it easy.
                      </p>
                    </div>
                  </div>
                  <div
                    className="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0"
                    id="colBox"
                  >
                    <div
                      className="icon-box"
                      data-aos="fade-up"
                      data-aos-delay={300}
                    >
                      <div className="icon">
                        <i className="fa icon fa-thermometer reverse round big color2" />
                      </div>
                      <h4 className="title">
                        <a href="">SIMPLE FUNDRAISING</a>
                      </h4>
                      <p className="description">
                        Built-in fundraising tools make text donations a cinch
                        and help drive more giving. An animated giving meter
                        motivates donors too.
                      </p>
                    </div>
                  </div>
                  <div
                    className="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0"
                    id="colBox"
                  >
                    <div
                      className="icon-box"
                      data-aos="fade-up"
                      data-aos-delay={400}
                    >
                      <div className="icon">
                        <i className="fa icon fa-user-plus reverse round big color2" />
                      </div>
                      <h4 className="title">
                        <a href="">FREE SUPPORT</a>
                      </h4>
                      <p className="description">
                        Need help crafting your next campaign? Our team of
                        Textperts can provide creative input to execute a
                        winning stategy.
                      </p>
                    </div>
                  </div>
                  <div
                    className="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0"
                    id="colBox"
                  >
                    <div
                      className="icon-box"
                      data-aos="fade-up"
                      data-aos-delay={400}
                    >
                      <div className="icon">
                        <i className="fa icon fa-dollar reverse round big color2" />
                      </div>
                      <h4 className="title">
                        <a href="">PRICED TO PLEASE</a>
                      </h4>
                      <p className="description">
                        We offer text plans to fit your volume requirements, use
                        cases and budget. Request a short demo today to see the
                        system in action.
                      </p>
                    </div>
                  </div>
                  <div
                    className="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0"
                    id="colBox"
                  >
                    <div
                      className="icon-box"
                      data-aos="fade-up"
                      data-aos-delay={400}
                    >
                      <div className="icon">
                        <i className="fa icon fa-birthday-cake reverse round big color2" />
                      </div>
                      <h4 className="title">
                        <a href="">BEST PRACTICES</a>
                      </h4>
                      <p className="description">
                        Not only do we ‘bake-in’ vital regulatory best
                        practices, but our Textperts are also here to guide you
                        along the way to achieve texting success.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* ======= Features Section ======= */}
            <section id="features" className="features">
              <div className="container">
                <div className="section-title" data-aos="fade-up">
                  {/* <h2>Features</h2> */}
                  <h5>
                    Our texting solutions are trusted by businesses and
                    non-profits everywhere.
                  </h5>
                </div>
                <div className="row" data-aos="fade-up" data-aos-delay={300}>
                  <div className="col-lg-3 col-md-4">
                    <div className="icon-box">
                      <img
                        src={geHealthcare}
                        className="img-fluid"
                        alt=""
                        data-aos="zoom-in"
                        data-aos-delay={500}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 mt-4 mt-md-0">
                    <div className="icon-box">
                      <img
                        src={mercer}
                        className="img-fluid"
                        alt=""
                        data-aos="zoom-in"
                        data-aos-delay={500}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 mt-4 mt-md-0">
                    <div className="icon-box">
                      <img
                        src={agco}
                        className="img-fluid"
                        alt=""
                        data-aos="zoom-in"
                        data-aos-delay={500}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 mt-4 mt-lg-0">
                    <div className="icon-box">
                      <img
                        src={pathways}
                        className="img-fluid"
                        alt=""
                        data-aos="zoom-in"
                        data-aos-delay={500}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 mt-4">
                    <div className="icon-box">
                      <img
                        src={mtmp}
                        className="img-fluid"
                        alt=""
                        data-aos="zoom-in"
                        data-aos-delay={500}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 mt-4">
                    <div className="icon-box">
                      <img
                        src={trialLawyers}
                        className="img-fluid"
                        alt=""
                        data-aos="zoom-in"
                        data-aos-delay={500}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 mt-4">
                    <div className="icon-box">
                      <img
                        src={usRetina}
                        className="img-fluid"
                        alt=""
                        data-aos="zoom-in"
                        data-aos-delay={500}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 mt-4">
                    <div className="icon-box">
                      <img
                        src={zillowGroup}
                        className="img-fluid"
                        alt=""
                        data-aos="zoom-in"
                        data-aos-delay={500}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 mt-4">
                    <div className="icon-box">
                      <img
                        src={IndianaRecy}
                        className="img-fluid"
                        alt=""
                        data-aos="zoom-in"
                        data-aos-delay={500}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 mt-4">
                    <div className="icon-box">
                      <img
                        src={nfp}
                        className="img-fluid"
                        alt=""
                        data-aos="zoom-in"
                        data-aos-delay={500}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 mt-4">
                    <div className="icon-box">
                      <img
                        src={grandoaks}
                        className="img-fluid"
                        alt=""
                        data-aos="zoom-in"
                        data-aos-delay={500}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 mt-4">
                    <div className="icon-box">
                      <img
                        src={ibm}
                        className="img-fluid"
                        alt=""
                        data-aos="zoom-in"
                        data-aos-delay={500}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section id="portfolio" className="portfolio">
              <div className="container">
                <div className="section-title" data-aos="fade-up">
                  <h2>Strategic Integrations</h2>
                  <p>
                    GivBee works seamlessly with the best tools for fundraising,
                    event management and more.
                  </p>
                </div>

                <div
                  className="row portfolio-container"
                  data-aos="fade-up"
                  data-aos-delay={400}
                >
                  <div
                    className="col-lg-4 col-md-6 portfolio-item filter-app"
                    id="strategicBox"
                  >
                    <a href="https://www.softerware.com/" target="_blank">
                      <div>
                        <img src={croppedDonor} className="img-fluid" alt="" />
                      </div>
                    </a>
                  </div>
                  <div
                    className="col-lg-4 col-md-6 portfolio-item filter-web"
                    id="strategicBox"
                  >
                    <a href="https://www.neoncrm.com/" target="_blank">
                      <div>
                        <img src={neonOne} className="img-fluid" alt="" />
                      </div>
                    </a>
                  </div>
                  <div
                    className="col-lg-4 col-md-6 portfolio-item filter-app"
                    id="strategicBox"
                  >
                    <a href="https://www.blackbaud.com/" target="_blank">
                      <div>
                        <img src={BBISVPartner} className="img-fluid" alt="" />
                      </div>
                    </a>
                  </div>
                  <div
                    className="col-lg-4 col-md-6 portfolio-item filter-card"
                    id="strategicBox"
                  >
                    <a href="https://www.cvent.com/" target="_blank">
                      <div>
                        <img src={cvent} className="img-fluid" alt="" />
                      </div>
                    </a>
                  </div>
                  <div
                    className="col-lg-4 col-md-6 portfolio-item filter-web"
                    id="strategicBox"
                  >
                    {" "}
                    <a href="" target="_blank">
                      <div>
                        <img src={condosites} className="img-fluid" alt="" />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </section>

            {/* End Portfolio Section */}
            <section id="more-services" className="more-services">
              <div className="container">
                <div className="row">
                  <div className="col-md-12 d-flex align-items-stretch">
                    <div
                      className="card"
                      // style={{
                      //   backgroundImage: "url(" + { moreServices } + ")",
                      // }}
                      data-aos="fade-up"
                      data-aos-delay={100}
                      id="more-services-card"
                    >
                      <div className="card-body">
                        <h5 className="card-title">TO SCHEDULE A DEMO,</h5>
                        <h5>call (844) 407-1996</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>

          <Footer />

          {/* End Footer */}
          <a
            href="#"
            className="back-to-top d-flex align-items-center justify-content-center"
          >
            <i className="bi bi-arrow-up-short" />
          </a>
          {/* Vendor JS Files */}
          {/* Template Main JS File */}
        </>
      </>
    );
  }
}

export default withRouter(Home);
